import { useCreation, useMemoizedFn } from 'ahooks'
import { Cascader } from 'antd'
import { isNil, last } from 'lodash'

import { findTreePaths } from '@eastcoal/common/utils/array'
import { pick } from '@eastcoal/common/utils/object'

import { useMemberDeptUserStore } from '../../Store/hooks/useStore'

import { MemberDeptUserCascaderCoreProps } from './interface'
import { transformMemberDeptUserCascadeData } from './transformCascaderData'

export const MemberDeptUserCascaderCore = ({
  allowClear = true,
  autoFocus,
  disabled
}: MemberDeptUserCascaderCoreProps) => {
  const { data, multiple, selectedKeys, setSelectedKeys } =
    useMemberDeptUserStore(state =>
      pick(state, ['data', 'multiple', 'selectedKeys', 'setSelectedKeys'])
    )

  const options = useCreation(
    () => transformMemberDeptUserCascadeData(data),
    [data]
  )

  const handleChange = useMemoizedFn((keys?: string[] | string[][]) => {
    // 清空
    if (isNil(keys) || keys.length === 0) {
      setSelectedKeys([])
    }
    // 多选
    else if (multiple) {
      setSelectedKeys(keys.map(item => `${last(item)}`))
    }
    // 单选
    else {
      setSelectedKeys([`${last(keys as string[])}`])
    }
  })

  const value = useCreation(() => {
    return selectedKeys.length && options.length
      ? selectedKeys
          .map(key => findTreePaths(options, node => node.value === key))
          .map(item => item.map(node => `${node.value}`))
          .filter(item => item.length)
      : undefined
  }, [selectedKeys, options])
  return (
    <Cascader
      showSearch
      allowClear={allowClear}
      autoFocus={autoFocus}
      changeOnSelect={false}
      disabled={disabled}
      multiple={multiple as any}
      options={options}
      showCheckedStrategy={Cascader.SHOW_CHILD}
      value={value}
      onChange={handleChange as any}
    />
  )
}
